<template>
    <ui-modal-message-v2
        name="code-confirm-modal"
        service="user" 
        :cancel-button="true"
        :color-square="'primary'"
        icon-square
        :dynamic-icon="icon"
        :width-dynamic-icon="24"
        :height-dynamic-icon="16"
        @close-modal="closeModalAction"
    >
        <template #title >
            <slot name="title"/>
            <div>
                <span class="primary-title">{{ titleConfirmModal }}</span> 
                <span class="secundary-title">{{ secundaryTitleConfirmModal }}</span>
            </div>
        </template>
        <template #text>
            <div class="text-container">
                <slot name="body" />
                <div class="text-alert">
                    {{ modalAlert }}
                </div>
                <div class="inputs-container">
                    <input
                        v-for="(digit, index) in code"
                        :key="index"
                        ref="inputs"
                        v-model="code[index]"
                        v-mask="'#'"
                        maxlength="1"
                        max="1"
                        type="number"
                        class="code-input"
                        :class="{ 'error-state': errorHandle }"
                        @input="handleInput(index)"
                        @keydown.delete="handleDelete(index)"
                    />
                    <ui-circle-v v-if="valideHandle" :design="'ml4px'"/>
                    <ui-circle-x v-if="errorHandle" :design="'ml4px'"/>
                </div>
                <div class="code-text">
                    <p>Digite o código <span class="code-number">{{ generatedCode }}</span> para confirmar</p>
                </div>
            </div>
        </template>
        <template #footer>
            <ui-button :design="design" :disabled="disableButtonHandler" @click="onConfirm">{{ textConfirmButton }}</ui-button>
        </template>
    </ui-modal-message-v2>
</template>

<script>
    import { uiButton } from '@/components/ui/buttons'
    import { uiLoadIndicator } from '@/components/ui'
    import { uiModalMessageV2 } from '@/components/ui/modal';

    import { mask } from 'vue-the-mask'

    export default {
        name: 'code-confirm-modal',
        components: {
            uiButton,
            uiModalMessageV2,
            uiLoadIndicator,
        },

        directives: {
            mask
        },

        props:{
            icon:{
                type: String,
                default: 'ui-allotment-icon',
                required: true
            },
            titleConfirmModal:{
                type: String,
                default: '',
                required: false
            },
            secundaryTitleConfirmModal: {
                type: String,
                default: '',
                required: false
            },
            modalAlert: {
                type: String,
                default: '',
                required: false
            },
            textConfirmButton:{
                type: String,
                default: 'Confirmar',
                required: true
            },
            onConfirm: {
                type: Function,
                required: true,
            },
            closeModalAction: {
                type: Function,
                required: false
            },
            design: {
                type: String,
                required: false,
                default: 'md danger'
            }
        },

        data(){
            return{
                code: ["", "", "", ""],
                generatedCode: "",
                disableButtonHandler: true,
                errorHandle: false,
                valideHandle:false,
            }
        },
        watch: {
            code: {
                handler() {
                    this.validateCode();
                },
                deep: true
            }
        },

        mounted() {
            this.$root.$on('modal-msg-open-code-confirm-modal', this.resetModal);
            this.generateCode();
        },

        methods: {
            generateCode() {
                this.generatedCode = "";
                for (let i = 0; i < 4; i++) {
                    this.generatedCode += Math.floor(Math.random() * 10);
                }
            },
            handleInput(index) {
                if (this.code[index] && index < this.code.length - 1) {
                    this.$refs.inputs[index + 1].focus();
                }
            },
            handleDelete(index) {
                if (!this.code[index] && index > 0) {
                    this.$refs.inputs[index - 1].focus();
                }
            },
            validateCode() {
                const codeString = this.code.join("");

                if (codeString.length < 4) {
                    this.disableButtonHandler = true;
                    this.errorHandle = false;
                    this.valideHandle = false;
                    return;
                }

                if (codeString === this.generatedCode) {
                    this.disableButtonHandler = false;
                    this.errorHandle = false;
                    this.valideHandle = true;
                } else {
                    this.disableHandler = true;
                    this.errorHandle = true;
                    this.valideHandle = false;
                }
                            },
            resetModal() {
                this.code = ["", "", "", ""]; // Limpa os inputs
                this.disableButtonHandler = true; // Desabilita o botão novamente
                this.errorHandle =  false
                this.valideHandle = false
                this.generateCode(); // Gera um novo código
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>